(function() { window.GUID_49ee4740_919e_4433_9de3_aecdaf754fa9 = { getGuid: function() { return "49ee4740-919e-4433-9de3-aecdaf754fa9"; } }; })();
var CS;
(function (CS) {
    class ScrollListener {
        constructor(jqueryElement) {
            this.timerReset = null;
            this.lastScroll = 0;
            this.lastDirection = "";
            let me = this;
            me.$scrolledElement = jqueryElement;
            me.$scrolledElement.offon('scroll.scrolllistener', function (e) {
                if (me.OnScrollChange != null) {
                    me.OnScrollChange();
                }
            });
            me.$scrolledElement.offon('touchmove.scrolllistener', function (e) {
                if (me.OnScrollChange != null) {
                    me.OnScrollChange();
                }
            });
        }
        scrollChange() {
            if (this.OnScrollChange != null) {
                this.OnScrollChange();
            }
            this.testScrollDirectionChange();
        }
        testScrollDirectionChange() {
            let me = this;
            clearTimeout(me.timerReset);
            me.timerReset = setTimeout(function () {
                let currentScroll = me.$scrolledElement.scrollTop();
                let currentDirection = me.lastDirection;
                if (currentScroll > me.lastScroll && currentScroll > 50) {
                    currentDirection = "down";
                    if (me.OnScrollDirectionChange != null && currentDirection != me.lastDirection) {
                        me.OnScrollDirectionChange.call(this, "down");
                    }
                }
                else if (currentScroll < me.lastScroll) {
                    currentDirection = "up";
                    if (me.OnScrollDirectionChange != null && currentDirection != me.lastDirection) {
                        me.OnScrollDirectionChange.call(this, "up");
                    }
                }
                me.lastScroll = currentScroll;
                me.lastDirection = currentDirection;
            }, 0);
        }
    }
    CS.ScrollListener = ScrollListener;
})(CS || (CS = {}));

//# sourceMappingURL=scroll-listener.pre.js.map
